export class TrafficSourceHelper {
	TRAFFIC_SOURCE = 'traffic_source';
	SESSION_TTL = 1800;

	constructor(params, url) {
		this.url = url;
		this.params = params;
	}

	get DataStorage() {
		if (!window.Loot || !window.Loot.DataStorage) return null;

		return window.Loot.DataStorage;
	}

	isUTMPresent() {
		return this.params.get('utm_source') ? true : false;
	}

	getLocalStorageInformation() {
		return this.DataStorage.retrieve(this.TRAFFIC_SOURCE);
	}

	localStorageDataInitialized() {
		return this.getLocalStorageInformation() !== '';
	}

	initLocalStorageInformation() {
		this.DataStorage.init();

		const localStorageInformation = {
			utm_source: {
				url: this.url.toString(),
				source: this.isUTMPresent() ? this.params.get('utm_source') : "No UTM Source",
			}
		};

		this.DataStorage.store(this.TRAFFIC_SOURCE, localStorageInformation, this.SESSION_TTL);
	}
}
